module.exports = __webpack_public_path__ + "static/media/energy_card_multi_3.d14bffc9.svg";